import { ExportToCsv } from 'export-to-csv'
import * as moment from 'moment'
import { HttpResult } from 'widgets-for-react'
import { getCsrfToken } from '../../utils/csrf'
import { prefixUrlWithLocale } from '../../utils/url'
import { CollectiveWithTariff } from './taxesState'

export const exportToCsv = (rows: CollectiveWithTariff[]) => {
  const options = {
    fieldSeparator: ',',
    filename: I18n.t('superadmin.taxes.overview_title'),
    useTextFile: false,
    showLabels: true,
    headers: [
      I18n.t('superadmin.taxes.entity'),
      I18n.t('superadmin.taxes.value')
    ],
    useBom: false
  }
  const csvExporter = new ExportToCsv(options)
  csvExporter.generateCsv(
    rows.map(ct => ({
      entity: `${ct.collective_name} (${ct.collective_external_id})`,
      amount: ct.tariff_value
    }))
  )
}

export async function getWithinRange(
  startDate: moment.Moment,
  endDate: moment.Moment
): Promise<HttpResult<CollectiveWithTariff[]>> {
  const res = await fetch(
    prefixUrlWithLocale(
      `/superadmin/taxes/tariffs_within_range?startdate=${startDate.format(
        'YYYY-MM-DD'
      )}&enddate=${endDate.format('YYYY-MM-DD')}`
    )
  )

  if (!res.ok) {
    return { kind: 'failed', status: res.status }
  }
  const tariffs = (await res.json()) as CollectiveWithTariff[]
  return { kind: 'result', value: tariffs, status: 200 }
}
